export default __webpack_public_path__ + "static/media/mailIcon.2c378c9e.png";